import { render, staticRenderFns } from "./pageMode4.vue?vue&type=template&id=47d288aa"
import script from "./pageMode4.vue?vue&type=script&lang=js"
export * from "./pageMode4.vue?vue&type=script&lang=js"
import style0 from "./pageMode4.vue?vue&type=style&index=0&id=47d288aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports